import { render, staticRenderFns } from "./AccordionView.vue?vue&type=template&id=22132f76&scoped=true"
import script from "./AccordionView.vue?vue&type=script&lang=js"
export * from "./AccordionView.vue?vue&type=script&lang=js"
import style0 from "./AccordionView.vue?vue&type=style&index=0&id=22132f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22132f76",
  null
  
)

export default component.exports